import React, { Component } from 'react'
import { connect } from 'react-redux'
import clearUnsupportedQualifierPrices from '../../../actions/clearUnsupportedQualifierPrices'
import setActiveStep from '../../../actions/setActiveStepActions'
import fetchPackages from '../../../actions/fetchPackages'
import { resetPackages } from '../../../actions/resetQuoteFlow'

import updateSearchParams from '../../../utilities/updateSearchParams'
import triggerCustomGaEvent from '../../../utilities/triggerCustomGaEvent'
import {
  setActiveGuestCount,
  setActivePage,
  setActiveCurrency
} from '../../../actions/setActiveSearchFilters'

class EQuoteSearchFiltersFullFormSubmit extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  submitQueryPackages() {
    const {
      activeSearchFilterData,
      handleSubmitQueryPackages,
      handleSetActiveCurrency,
      handleResetPackages,
      loyaltyData,
      shouldResetPackages,
      ssoData
    } = this.props

    const resolvedCurrency =
      activeSearchFilterData.currency ||
      (ssoData && ssoData.transactionData && ssoData.transactionData.defaultCurrencyCode)

    if (resolvedCurrency && resolvedCurrency !== activeSearchFilterData.currency) {
      handleSetActiveCurrency(resolvedCurrency)
    }

    const disabledBrands = (ssoData && ssoData.disabledBrands) || []
    const filteredBrand = activeSearchFilterData.brand
      ? activeSearchFilterData.brand
          .split(',')
          .filter(b => !disabledBrands.includes(b))
          .join(',')
      : activeSearchFilterData.brand
    updateSearchParams({
      ...activeSearchFilterData,
      brand: filteredBrand,
      currency: resolvedCurrency
    })
    this.props.handleActiveGuestCount(activeSearchFilterData.guestCount)
    this.props.clearUnsupportedQualifierPrices()
    this.props.handleSetActivePage(1)
    if (shouldResetPackages) {
      handleResetPackages()
    }
    handleSubmitQueryPackages(ssoData)

    // Dispatch submit and edit click events
    triggerCustomGaEvent('equoteSearchClick', {
      ...activeSearchFilterData,
      ...loyaltyData
    })
  }

  handleClick = () => {
    const { onClickIntercept } = this.props
    const proceed = () => this.submitQueryPackages()
    if (onClickIntercept && onClickIntercept(proceed)) {
      return
    }
    proceed()
  }

  render() {
    const { isSearchEnabled } = this.props

    return (
      <button
        className="btn btn-primary"
        disabled={!isSearchEnabled}
        onClick={isSearchEnabled ? this.handleClick : null}
      >
        Search
      </button>
    )
  }
}

const mapStateToProps = state => {
  return {
    loyaltyData: state.loyaltyData,
    ssoData: state.ssoData
  }
}

const mapDispatchToProps = dispatch => ({
  handleSubmitQueryPackages(ssoData) {
    dispatch(fetchPackages(ssoData))
    dispatch(setActiveStep(1))
  },
  clearUnsupportedQualifierPrices() {
    dispatch(clearUnsupportedQualifierPrices())
  },
  handleActiveGuestCount(count) {
    return dispatch(setActiveGuestCount(count))
  },
  handleSetActivePage(page) {
    dispatch(setActivePage(page))
  },
  handleSetActiveCurrency(currency) {
    dispatch(setActiveCurrency(currency))
  },
  handleResetPackages() {
    dispatch(resetPackages())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EQuoteSearchFiltersFullFormSubmit)
